import BaseService from "./Base"
import {ApiListResponse, ApiResponse} from "types/api"
import {AxiosResponse} from "axios"

class ProfileContactsServiceV3 extends BaseService {
    getAll = async (params = {}) => {
        const defaultParams = {
            range: {
                limit: 10,
                offset: 0
            },
            sort: {
                orderBy: "id",
                orderDir: "ASC"
            }
        }
        const {data: response}: AxiosResponse<ApiListResponse<any[]>> = await this.post(
            "/v1/users/profile/contacts/list",
            {
                ...defaultParams,
                ...params
            }
        )
        if (!response.success) {
            throw response
        }
        response.data = response.data.map((contact) => {
            return contact
        })
        return response
    }

    getByProfile = async (id: number, type: string): Promise<any | null> => {
        const {data: response}: AxiosResponse<ApiResponse<any[]>> = await this.post("/v1/users/profile/contacts/list", {
            filter: {
                profileId: [id]
            },
            linkedObjects: true
        })
        if (!response.success) {
            throw response
        }
        response.data = response.data.map((contact) => {
            return contact
        })
        return response
    }

    create = async (params) => {
        const {data: response}: AxiosResponse<ApiResponse> = await this.post(
            "/v1/users/profile/contacts/create",
            params
        )
        if (!response.success) {
            throw response
        }
        return response.data
    }

    update = async (id, params: any = {}) => {
        params.id = id
        const {data: response}: AxiosResponse<ApiResponse> = await this.post("/v1/users/profile/contacts/edit", params)
        if (!response.success) {
            throw response
        }
        return response.data
    }

    delete = async (params) => {
        const {data: response}: AxiosResponse<ApiResponse> = await this.post("/v1/users/profile/contacts/delete", {
            filter: {
                id: [params]
            }
        })
        if (!response.success) {
            throw response
        }
        return response.data
    }

    invite = async (params) => {
        const {data: response}: AxiosResponse<ApiResponse> = await this.post(
            "/v1/users/profile/contacts/invite",
            params
        )
        if (!response.success) {
            throw response
        }
        return response.data
    }
}
export default ProfileContactsServiceV3
